'use client';
import styles from './search.module.css';
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faArrowUpRightFromSquare,
	faBullseyePointer,
	faChartLine,
	faClock,
	faCrosshairs,
	faMagnifyingGlass,
	faUser,
} from '@awesome.me/kit-012d1b9af0/icons/classic/regular';
import { useProperties } from '@/context/properties-context';
import PlacesAutocomplete from './autocomplete';
import { injury, severity, time } from './data';
import {
	InjuryModal,
	SeverityModal,
	TimeModal,
} from '@/components/modal/properties-modal/properties-modal';
import useModal from '@/components/modal/use-modal';
import useGeoLocationAddress from '@/hooks/use-location';
import { Field } from '@/components/main/field/field';

export default function Search() {
	const { properties, updateProperty } = useProperties();

	const [_, getLocation] = useGeoLocationAddress();

	const { isOpen, onOpen, onClose } = useModal();

	return (
		<div className={styles.search}>
			<h1 className={styles.title}>Find Spinal Cord Injury Clinical Trials</h1>

			<div className={styles.features}>
				<div className={styles.feature}>
					<FontAwesomeIcon icon={faMagnifyingGlass} color='white' size='lg' />
					<p>find trials</p>
				</div>
				<div className={styles.feature}>
					<FontAwesomeIcon
						icon={faArrowUpRightFromSquare}
						color='white'
						size='lg'
					/>
					<p>get latest updates</p>
				</div>
				<div className={styles.feature}>
					<FontAwesomeIcon icon={faBullseyePointer} color='white' size='lg' />
					<p>apply online</p>
				</div>
			</div>

			<div className={styles.hairline} />

			<div className={styles.searches}>
				<Field>
					<Field.Icons icon={faCrosshairs} onClick={getLocation} animate />
					<PlacesAutocomplete />
				</Field>

				<Field>
					<Field.Icons icon={faUser} onClick={() => onOpen('injury-modal')}>
						<InjuryModal
							isOpen={isOpen('injury-modal')}
							onClose={() => onClose('injury-modal')}
						/>
					</Field.Icons>
					<Field.Content
						title={injury.title}
						labelValue={injury['label-value']}
						value={properties.injury}
						onFieldChange={(value) => updateProperty('injury', value)}
					/>
				</Field>

				<Field>
					<Field.Icons
						icon={faChartLine}
						onClick={() => onOpen('severity-modal')}
					>
						<SeverityModal
							isOpen={isOpen('severity-modal')}
							onClose={() => onClose('severity-modal')}
						/>
					</Field.Icons>
					<Field.Content
						title={severity.title}
						labelValue={severity['label-value']}
						value={properties.severity}
						onFieldChange={(value) => updateProperty('severity', value)}
					/>
				</Field>

				<Field>
					<Field.Icons icon={faClock} onClick={() => onOpen('time-modal')}>
						<TimeModal
							isOpen={isOpen('time-modal')}
							onClose={() => onClose('time-modal')}
						/>
					</Field.Icons>
					<Field.Content
						title={time.title}
						labelValue={time['label-value']}
						value={properties.time}
						onFieldChange={(value) => updateProperty('time', value)}
					/>
				</Field>
			</div>

			<div className={styles['search-btn-container']}>
				<Link href={'/triallist'} className={styles['search-btn']}>
					find trials
				</Link>
			</div>
		</div>
	);
}
